import { MappedAnswer } from '../components/context/SurveyPageContext';
import Question from '../interfaces/question';
import { findAnswer } from './findAnswer';

interface RetrievePageErrorsProps {
  currentPage: Question[];
  currentPageAnswers: MappedAnswer[];
}

const retrievePageErrors = ({
  currentPage,
  currentPageAnswers,
}: RetrievePageErrorsProps): Map<number, string[]> =>
  currentPage.reduce((acc, question) => {
    const result = findAnswer({ question, currentPageAnswers });
    const questionErrors = question.validate(result);
    if (questionErrors.length > 0) acc.set(question.id, questionErrors);
    return acc;
  }, new Map());

export { retrievePageErrors };
